import { lazy } from "react";

const Login = lazy(() => import("../Component/Login/Login"));
const ForgotMobile = lazy(() => import("../Component/Login/ForgotMobile"));
const ChangePassword = lazy(() => import("../Component/ForgotPassword/ChangePassword"));
const ResetPassword = lazy(() => import("../Component/Login/ResetPassword"));
const Profile1 = lazy(() => import("../Component/Profile/Profile1"));
const ChangeEmail = lazy(() => import("../Component/Profile/ChangeEmail"));
const ChangePhoneNo = lazy(() => import("../Component/Profile/ChangePhoneNo"));

const authRoutes = [
  { path: "/", element: <Login />, protected: false },
  { path: "/forgot-password", element: <ForgotMobile />, protected: false },
  { path: "/change-password", element: <ChangePassword />, protected: true },
  { path: "/reset-password", element: <ResetPassword />, protected: false },
  { path: "/profile", element: <Profile1 />, protected: true },
  { path: "/change-email", element: <ChangeEmail />, protected: true },
  { path: "/change-phone-no", element: <ChangePhoneNo />, protected: true },
];

export default authRoutes;
